module.exports = __webpack_public_path__ + "assets/img/bananominer-logo.7f7cf2c9ca385843a5aa2b8a7d0b3b75.svg";